const MainContainer = ({ children }) => {
  return (
    <div className='antialiased relative'>
      {children}
    </div>
  );
};

export default MainContainer;
